import React from 'react';

const TermsHeader = () => {
  return (
    <div className="page-hero-bg relative overflow-hidden text-white text-center bg-gradient-to-br from-icetex to-icetex-dark py-[80px] px-5">
      <div className="mx-auto relative z-10 max-w-[800px]">
        <h1
          className="font-extrabold mb-4"
          style={{ fontSize: '3rem', textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)' }}
        >
          Términos y Condiciones
        </h1>
        <p className="opacity-[0.95]" style={{ fontSize: '1.2rem' }}>
          Portal Web de Cursos Virtuales ICETEX - www.cursosvirtualesicetex.com
        </p>
      </div>
    </div>
  );
};

export default TermsHeader;
